<template>

          <!-- :remote-method="getData" -->
  <Select v-if="isMultiple == 1" v-model="hasChecked"
          filterable
          remote
          :clearable="clearable"
          :loading="loading"
          @on-change="setVal"
          @on-clear="getData"
          :remote-method="getData"
          multiple
         :placeholder='placeholderText'
  >
    <Option v-for="(item) in dataList"  :label="item[labelName]" :value="item[valName]" :key="item.id" style='display:flex;align-items: center;justify-content: space-between;'><span>{{ item[labelName] }}</span>  <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
  </Select>

  <Select v-else-if='isMultiple == 2'
          v-model="hasChecked"
          filterable
          remote
          :clearable="clearable"
          :loading="loading"
          :remote-method="getData"
          @on-change="setVal"
          @on-clear="getData"
           :placeholder='placeholderText'
  >
    <Option v-for="(item) in dataList" :label="item[labelName]" :value="item[valName]" :key="item.id" style='display:flex;align-items: center;justify-content: space-between;'><span>{{ item[labelName] }}</span> <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
  </Select>

  <Select v-else-if='isMultiple == 3'
          v-model="hasChecked"
          filterable
          remote
          :clearable="clearable"
          :loading="loading"
          @on-change="setVal"
          @on-clear="getData"
          :remote-method="getData"
        :placeholder='placeholderText'
        @on-create="handleCreate1"
        :allow-create='allowCreate'
  >
    <Option v-for="(item,index) in dataList" :value="item" :key="index" style='display:flex;align-items: center;justify-content: space-between;'>{{ item }}</Option>
  </Select>
</template>
<script>
    import common from '@/common/common.js';

    export default {
        name: "selectList",
        components: {
        },
        props: {
            url: String,//接口的链接
            valName: String,//传入后台的值
            labelName: String,//对外显示的说明
            isMultiple:{ //是否多选  1  多选 2单选 3 单选 直接数据
                type: [Number,String],
                default: 2
            },
            keyword: { //搜索词的字段名
                type: String,
                default: ''
            },
            labelNameNew: { //备注字段
                type: String,
                default: ''
            },
            clearable:{//是否可清空
                type: Boolean,
                default: true
            },
            checkedList:{//选中的值 多选时传入数组
                type: String|Array,
                default: ''
            },
            placeholderText:{
                type:[String,Number],
                default:'请输入'
            },
            index:{//操作对应的索引
                type: Number,
                default: 0
            },
            allowCreate:{
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading:false,
                dataList:[],
                hasChecked:[]
            }
        },

        created() {
            this.getData()
        },
        mounted() {
            this.$nextTick(() => {
                if(this.checkedList.length >0){
                    this.hasChecked = this.checkedList
                }
            })

        },
        destroyed() {
        },
        methods: {
            handleCreate1(val){
                this.dataList.push(val)
            },
            getData(query){//获取列表信息
                let params = {}
                params[this.keyword] = query

                let getData = {
                    params:params
                }
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;

                    this.axios.get(this.url,getData).then((result) => {
                        //处理数组
                        if(result.data.code == 1){
                            if(this.isMultiple == 3){
                                this.dataList = result.data.data
                            }else{
                                this.dataList = result.data.data.list != undefined?result.data.data.list:result.data.data
                            }
                        }else{
                            common.msg('error',result.data.message,()=>{})
                        }
                    }).catch((err) => {
                        common.msg('error','获取失败',()=>{})
                    });

                }, 200);
            },
            setDefVal(val){//设置默认值
                this.hasChecked = val
            },
            setVal(data){
                let nowData = ''

                if(this.isMultiple == 1){
                    nowData = []
                    this.dataList.forEach((item)=>{
                        data.map((item2,index2)=>{
                            if(item.id == item2){
                               nowData.push(item)
                            }
                        })
                    })
                }else{
                    this.dataList.forEach((item)=>{
                        if(item.id == data){
                            nowData = item
                        }
                    })
                }
                this.$emit('setSelected', data, {index:this.index,dataList:nowData})
                // this.$emit('setSelected', data,this.dataList)
            },
            clearVal(){
              this.hasChecked = []
            }
        }
    }
</script>
<style scoped>

  .feedbackText {
    font-size: 10px;
  }
</style>
